import { Star } from "lucide-react";

const Testimonials = () => {
    const reviews = [
        {
            name: "Neha Rani",
            text: "Amazing experience! Everything was well organized.",
            rating: 5,
        },
        {
            name: "Kajal Gupta",
            text: "Best city tour I’ve ever taken. Totally worth it!",
            rating: 5,
        },
        {
            name: "Nitesh",
            text: "Professional guides and smooth booking process.",
            rating: 4,
        },
        {
            name: "Saqlain Shaikh",
            text: "Professional guides and smooth booking process.",
            rating: 5,
        },
        {
            name: "Nitin Yadav",
            text: "Professional guides and smooth booking process.",
            rating: 5,
        },
        {
            name: "Sandeep Sharma",
            text: "Professional guides and smooth booking process.",
            rating: 4,
        },
    ];

    return (
        <section className="bg-gradient-to-b from-blue-100 via-indigo-100 to-white py-24">
            <div className="max-w-6xl mx-auto px-6 text-center">
                {/* Heading */}
                <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
                    What Travelers Say
                </h2>
                <p className="mt-3 text-gray-600">
                    Trusted by thousands of happy travelers across India
                </p>

                {/* Cards */}
                <div className="grid md:grid-cols-3 gap-8 mt-16">
                    {reviews.map((review, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl p-7
                                       shadow-md hover:shadow-xl
                                       transition-all duration-300"
                        >
                            {/* Stars */}
                            <div className="flex justify-center mb-4">
                                {[...Array(review.rating)].map((_, i) => (
                                    <Star
                                        key={i}
                                        className="w-5 h-5 text-yellow-400 fill-yellow-400"
                                    />
                                ))}
                            </div>

                            <p className="text-gray-600 mb-6">
                                “{review.text}”
                            </p>

                            <h4 className="font-semibold text-gray-900">
                                {review.name}
                            </h4>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
